<template>
    <div class="register w-100 h-100 d-flex">
        <div class="register-rail d-none d-md-flex flex-column justify-content-between p-5">
            <div class="d-flex align-items-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-2"><circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/><path d="M6 17 10 8h5l3 9M10 8 8 4H5"/></svg>
                <span class="register-rail-brand">VueltaCiclista</span>
            </div>
            <div>
                <div class="register-rail-title">Únete a la<br>{{ utils.get_season_label(window_mode).toLowerCase() }}</div>
                <div class="register-rail-rule"></div>
            </div>
            <div class="register-rail-footer">Regístrate y participa a tu ritmo</div>
        </div>

        <div class="flex-fill d-flex justify-content-center align-items-center p-3 overflow-auto">
            <div class="register-card">
                <template v-if="!success">
                    <div class="mb-4">
                        <h1 class="register-card-title">Crea tu cuenta</h1>
                        <div class="register-card-subtitle">Regístrate con tu email para participar</div>
                    </div>

                    <div v-if="error" class="register-error mb-3">{{ error }}</div>

                    <div class="mb-3">
                        <label class="register-field-label">Nombre</label>
                        <input type="text" class="form-control" id="register-name" v-model="name" placeholder="Tu nombre" :disabled="submitting"/>
                    </div>
                    <div class="mb-3">
                        <label class="register-field-label">Email</label>
                        <input type="email" class="form-control" id="register-email" v-model="email" placeholder="tucorreo@ejemplo.com" :disabled="submitting"/>
                    </div>
                    <div class="mb-3">
                        <label class="register-field-label">Contraseña</label>
                        <input type="password" class="form-control" id="register-password" v-model="password" placeholder="Mínimo 6 caracteres" :disabled="submitting"/>
                    </div>
                    <div class="mb-4">
                        <label class="register-field-label">Confirmar contraseña</label>
                        <input type="password" class="form-control" id="register-password-confirm" v-model="password_confirm" placeholder="Repite la contraseña" :disabled="submitting"/>
                    </div>

                    <button type="button" class="btn btn-primary w-100" :disabled="submitting" @click="submit">
                        <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>{{ submitting ? 'Creando cuenta...' : 'Crear cuenta' }}
                    </button>

                    <div class="register-back mt-4 text-center">
                        <a href="#" @click.prevent="$router.push({name: 'Login'})">¿Ya tienes cuenta? Inicia sesión</a>
                    </div>
                </template>

                <template v-else>
                    <div class="register-success text-center">
                        <i class="bi bi-check-circle-fill register-success-icon"></i>
                        <div class="register-success-headline">¡Casi listo!</div>
                        <div class="register-success-detail">
                            Tu cuenta para <strong>{{ email }}</strong> se ha creado correctamente.
                        </div>
                        <button type="button" class="btn btn-primary mt-4" @click="$router.push({name: 'Login'})">Iniciar sesión</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/../../shared/utils'
import api from '@/api'

export default {
    name: 'Register',
    data(){
        return {
            utils: utils,
            window_mode: window.MODE,
            name: '',
            email: '',
            password: '',
            password_confirm: '',
            submitting: false,
            success: false,
            error: null,
        };
    },
    methods: {
        validate(){
            if(!this.name || this.name.trim() == '')
                return "Indica tu nombre.";
            if(!this.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email))
                return "Indica un email válido.";
            if(!this.password || this.password.length < 6)
                return "La contraseña debe tener al menos 6 caracteres.";
            if(this.password != this.password_confirm)
                return "Las contraseñas no coinciden.";
            return null;
        },
        async submit(){
            const validation_error = this.validate();
            if(validation_error){
                this.error = validation_error;
                return;
            }

            this.error = null;
            this.submitting = true;

            try{
                await api.register(this.name, this.email, this.password);
                this.success = true;
            }catch(ex){
                this.error = ex.message || "No se ha podido completar el registro.";
            }finally{
                this.submitting = false;
            }
        }
    }
}
</script>

<style scoped>
    .register-rail{
        width: 340px;
        flex-shrink: 0;
        background: var(--vc-ink-900);
        color: var(--vc-paper-50);
    }

    .register-rail-brand{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.9rem;
        letter-spacing: 0.04em;
    }

    .register-rail-title{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.9rem;
        text-transform: uppercase;
        line-height: 1.15;
    }

    .register-rail-rule{
        height: 3px;
        width: 60px;
        background: var(--vc-accent-500);
        margin-top: 20px;
    }

    .register-rail-footer{
        font-size: 0.8rem;
        color: rgba(255,255,255,0.5);
    }

    .register-card{
        width: 100%;
        max-width: 380px;
    }

    .register-card-title{
        font-size: 1.4rem;
    }

    .register-card-subtitle{
        color: var(--vc-text-600);
        font-size: 0.9rem;
        margin-top: 0.3rem;
    }

    .register-field-label{
        font-family: "Archivo", sans-serif;
        font-size: 0.7rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: var(--vc-text-600);
        margin-bottom: 0.4rem;
        display: block;
    }

    .register-error{
        background-color: var(--vc-danger-100);
        color: var(--vc-danger-500);
        border-radius: 8px;
        padding: 0.6rem 0.9rem;
        font-size: 0.85rem;
    }

    .register-back{
        font-size: 0.85rem;
    }

    .register-success-icon{
        font-size: 3rem;
        color: var(--vc-accent-500);
    }

    .register-success-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.4rem;
        margin-top: 12px;
    }

    .register-success-detail{
        color: var(--vc-text-600);
        margin-top: 8px;
    }
</style>
